import AuthenticatedEntity from "../user/AuthenticatedEntity";
import {Option} from "ts-option";
import moment = require("moment");

export default class PartnerBrandPointsSummary {
	hasPendingValues: boolean;
	hasSubmittedValues: boolean;

	constructor(public readonly id: string,
		public readonly creator: AuthenticatedEntity,
		public readonly createdAt: moment.Moment,
		public readonly quoteId: Option<string>,
		public readonly quoteReferenceNumber: Option<string>,
		public readonly description: Option<string>,
		public readonly pendingAmount: number,
		public readonly pendingUsedPoints: number,
		public readonly submittedAmount: number,
		public readonly submittedUsedPoints: number,
		public readonly notSaved: boolean) {
		this.hasPendingValues = pendingAmount > 0 || pendingUsedPoints > 0;
		this.hasSubmittedValues = submittedAmount > 0 || submittedUsedPoints > 0;
	}

	static compareByCreationDtDesc(pb1: PartnerBrandPointsSummary, pb2: PartnerBrandPointsSummary) {
		return pb1.createdAt.isAfter(pb2.createdAt, "minute") ? -1 : 1;
	}

	submitPendingPoints() {
		const submittedAmount = this.submittedAmount + this.pendingAmount;
		const submittedUsed = this.submittedUsedPoints + this.pendingUsedPoints;

		return new PartnerBrandPointsSummary(this.id, this.creator, this.createdAt, this.quoteId, this.quoteReferenceNumber,
			this.description, 0, 0, submittedAmount, submittedUsed, this.notSaved);
	}
}
